import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import ScoreCardForWriting from "./ScoreCardForWritingSection";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import AudioPlayer from "./AudioPlayer";
import WriteBox from "./WordBox";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import ScoreBoxForWritting from "./ResponseBoxForWrittingSection";
import Notification from "./Notification";
import Timers from "../PageComponent/Timers";
import Timer from "../MockTest/Timer";

export default function WriteFromDictationPage() {
  
  const { title } = useParams();

  // Fix later
  const section = "writefromdictation";
  const practiceItemId = title;


  const post = useFetchData(section, title); // Use the hook
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [audioLink, setaudioLink] = useState("");
  const [text, setText] = useState('');
  const [originalAnswer, setOriginalAnswer] = useState("");

  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [practiceType, setPracticeType] = useState("");
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null); // New state to store saved practice data
  const [loading, setLoading] = useState(false);

  const handleTextChange = (newText) => {
    setText(newText);
  };


  useEffect(() => {
    console.log("Post Data :", post);

    if (post && post.media_link) {
      setOriginalWords(post.question);
      setTitle(post.q_title);
      setOriginalAnswer(post.audio_script);

        // Extract file name from media_link
        const fileName = encodeURIComponent(post.media_link.split("/").pop());
  
        // Fetch the signed URL from the backend
        fetch(`/ptedata/ptemedia/${fileName}`, { credentials: "include" }) // Ensure cookies/session are sent
          .then((response) => response.json())
          .then((data) => {
            if (data.url) {
             setaudioLink(data.url); // Set the signed URL as the image source
            } else {
              console.error("Failed to fetch image URL");
            }
          })
          .catch((error) => console.error("Error fetching signed URL:", error));

    }
  }, [post]);

  console.log("Audio Link:", audioLink);
  console.log("Original Word:", originalWords);
  

  ////////////////////////////////////// Caculation/////////////////////////////////////////////

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-writefromdictation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  // const [result, setResult] = useState("");

  // useEffect(() => {

  //   const highlightMatchingWords = () => {
  //     const words1 = originalWords.split(" ");
  //     console.log("Word1",words1)
  //     const words2 = text;
  //     console.log("Word2",words2)

  //     const highlightedResult = words2.map((word2, index) => {
  //       if (words1.includes(word2)) {
  //         return (
  //           <span
  //             key={index}
  //             style={{ backgroundColor: "#CBFB8A", marginRight: "4px" }}
  //           >
  //             {word2}
  //           </span>
  //         );
  //       } else {
  //         return (
  //           <span
  //             key={index}
  //             style={{ backgroundColor: "#E74C3C", marginRight: "4px" }}
  //           >
  //             {word2}
  //           </span>
  //         );
  //       }
  //     });

  //     setResult(highlightedResult);
  //   };

  //   highlightMatchingWords();
  // }, [originalWords, text]);

  // console.log("Highlighted Text", result);

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    const answer = text;
    const practiceType = section;

    e.preventDefault();
    setLoading(true);

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer,
        isAttempted,
      },
    };
    console.log("practiceData:", practiceData);
    try {
      const result = await savePractice(practiceData);
      console.log("Practice data saved:", result);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error saving practice data:", error);
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true); // Show notification
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  console.log("savedPractice", savedPractice);

  // Callback function to handle the isAttempted value from the child component
  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={Title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
          para="You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.

"
        />

        {audioLink && <AudioPlayer audioSrc={audioLink} />}

        <div className="font-bold p-2 pt-4 text-center md:text-right md:ml-[1000px] "><Timer initialMinutes={10} initialSeconds={0} Text="Time Remaining" /></div>
        <WriteBox  onTextChange={handleTextChange} />
        <button
          className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-2 px-10 rounded-sm mt-3 ml-1 w-full max-w-[345px] sm:w-auto sm:ml-6"
          onClick={handleSubmit}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>Submitting...</span>
            </span>
          ) : (
            "Submit"
          )}
        </button>
        {submitted ? (
          <>
            {/* <ResultBox result={result} /> */}
            <ScoreCardForWriting
              finalScore={savedPractice?.savedResponse.totalScore}
              remarks={savedPractice?.savedResponse.remarks}
              contentScore={savedPractice?.savedResponse.contentScore}
              formScore={savedPractice?.savedResponse.formScore}
              grammarSpellingScore={
                savedPractice?.savedResponse.grammarSpellingScore
              }
              vocabularyScore={savedPractice?.savedResponse.vocabularyScore}
            />
          </>
        ) : null}  

        <ScoreBoxForWritting
          originalWords={originalAnswer}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />   
          {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
        <SpacingBox />
      </div>
    </div>
  );
}
